<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" (click)="decline()">×</button>
</div>

<div class="modal-body">
    <div *ngIf="!agentComissions">
        {{ message }}
    </div>

    <div *ngIf="agentComissions">
        <!-- 🔹 Exibe todas as comissões dinamicamente -->
        <h5>{{'comissions-bonus-agent.title.bonus' | translate}}</h5>
        <div *ngFor="let item of commissions" class="comission-card">
            <div class="comission-info">
                <span class="comission-title">{{ item.bookingTypeDescription | translate }}</span>
                <span class="comission-value">
                    {{'comissions-bonus-agent.label.bonus-for' | translate}} <b> {{ item.baseValue }}% </b>
                </span>
            </div>
            <div class="comission-icon">
                <img [src]="item.imagePath" alt="{{ item.bookingTypeDescription }}">
            </div>
        </div>

        <!-- 🔹 Exibe valores extra dinamicamente -->
        <h5>{{'comissions-bonus-agent.title.extra' | translate}}</h5>
        <div *ngFor="let item of commissions" class="comission-card">
            <div class="comission-info">
                <span class="comission-title">{{ item.bookingTypeDescription | translate }}</span>
                <span class="comission-value">
                    {{'comissions-bonus-agent.label.bonus-for' | translate}} <b> {{ item.extraValue }}% </b>
                </span>
            </div>
            <div class="comission-icon">
                <img [src]="item.imagePath" alt="{{ item.bookingTypeDescription }}">
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn-cancel" *ngIf="!noCancel" (click)="decline()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="accept()">OK</button>
</div>
